import { IItem, ITotals } from '@checkout/items';
import { IPaymentMethod, ISteps, RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { GiftWrap, OrderMessage, ProductsList, Voucher } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { layoutTypes } from '../../../config/contextCheckoutConfig';
import messages from './../../../i18n/base-en';
import { Button, OrderSection, PaymentLogosBar, SectionHeader, StepNumber, Summary } from './../../presentational';
import * as Styles from './OrderSummary.scss';

interface IOwnProps {
  isMobile: boolean;
  toggleOrderSummary?: (event: React.SyntheticEvent<HTMLElement>) => void;
}

interface IConnectedProps {
  items: IItem[];
  totals: ITotals;
  steps: ISteps;
  paymentMethods: IPaymentMethod[];
}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class OrderSummary extends React.Component<Props, {}> {

  render() {
    const { isMobile, items, totals, intl, toggleOrderSummary, paymentMethods } = this.props;
    const { formatMessage } = intl;

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <Fragment>
            <div className={Styles.column}>
              <OrderSection blockFor="CheckoutProductsList">
                <div className={Styles.header}>
                  <SectionHeader title={formatMessage(messages.order_summary_label)} />
                </div>
                <ProductsList items={items} giftWrapProductId={checkoutContextConfig.ui.giftWrap.productId} />
              </OrderSection>
              {checkoutContextConfig.ui.giftWrap.isEnabled &&
                checkoutContextConfig.ui.giftWrap.productId !== '' && (
                <OrderSection blockFor="GiftWrap">
                  <GiftWrap items={items} productId={checkoutContextConfig.ui.giftWrap.productId} />
                </OrderSection>
              )}
              {((checkoutContextConfig.ui.orderSummary.isVoucherVisible) || (!isMobile)) && (
                <OrderSection blockFor="CheckoutVoucher">
                  <Voucher id="orderSummaryVoucherInput" />
                </OrderSection>
              )}
              {checkoutContextConfig.ui.additionalNotes.enabled && (
                <OrderSection blockFor="CheckoutOrderMessage">
                  <OrderMessage />
                </OrderSection>
              )}
              <OrderSection blockFor="CheckoutSummary" borderBottom={false}>
                <Summary totals={totals} />
              </OrderSection>
              {isMobile && (
                <Fragment>
                  {checkoutContextConfig.ui.cartFooterNote.enabled &&
                        checkoutContextConfig.ui.cartFooterNote.html !== '' && (
                    <OrderSection blockFor="CartFooterNote" borderBottom={false}>
                      <div className={Styles.note} dangerouslySetInnerHTML={{ __html: checkoutContextConfig.ui.cartFooterNote.html }} />
                    </OrderSection>
                  )}
                  <OrderSection borderBottom={false}>
                    <Button
                      align="center"
                      label={formatMessage(messages.checkout_button_label)}
                      variant="primary"
                      type="button"
                      onClick={toggleOrderSummary}
                    />
                    {checkoutContextConfig.ui.cartPaymentLogoBar.enabled && (
                      <PaymentLogosBar paymentMethods={paymentMethods} />
                    )}
                  </OrderSection>
                </Fragment>
              )}
            </div>
            {checkoutContextConfig.ui.orderSummary.isStepTitleBarVisible && checkoutContextConfig.ui.layout.type === layoutTypes.steps && (
              <div className={Styles.stepBar} onClick={toggleOrderSummary}>
                <div className={Styles.stepBarInner}>
                  <StepNumber accent={true} icon={false} step={this.props.steps.current} />
                  <SectionHeader accent={true} title={this.props.steps.title} light={false} />
                </div>
              </div>
            )}
          </Fragment>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps>(
    (state: RootState) => ({
      items: state.checkout.selection.items,
      totals: state.checkout.selection.totals,
      steps: state.checkout.steps,
      paymentMethods: state.checkout.paymentMethods,
    }),
    {}
  )
)(OrderSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/OrderSummary/OrderSummary.tsx